// A horizontal bar list for ranking categories/providers by a value.
// items: [{ label, value, color, hint }]
export default function BarList({ items = [], formatValue = (v) => v }) {
  const max = Math.max(...items.map((i) => i.value || 0), 1);
  return (
    <ul className="barlist">
      {items.map((item, i) => (
        <li key={i} className="barlist__row">
          <div className="barlist__meta">
            <span className="barlist__label">{item.label}</span>
            <span className="barlist__value">{formatValue(item.value)}</span>
          </div>
          <div className="barlist__track">
            <div
              className="barlist__fill"
              style={{
                width: `${((item.value || 0) / max) * 100}%`,
                background: item.color || 'var(--accent)',
              }}
            />
          </div>
        </li>
      ))}
    </ul>
  );
}
